/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import { React, useState, useEffect, useContext } from 'react';
import App from '../../layout/App';
import {
    FormContent, Container, Message,
    BoxInput, Box, Box2Items,
    Box3Items, Select,
    Option, TitleFieldForm,
    Box25, Box30, Box50, Madatory
} from '../../styles/styles'
import Checkbox from '../../Components/checkbox';
import { useNavigate } from 'react-router-dom';
import InputResponsive1 from '../../Components/InputResponsive1';
import api from '../../utils/api'
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import Loading from '../../Components/Loading';
import { cpfMask, onlyNumber, onlyText } from '../../utils/mask';
import MessagePopUp from '../../Components/messagePopUp';
import InfoForm from '../../Components/infoForm'
import ButtonFormFooter from '../../Components/buttonFormFooter';
import { MessageContext } from '../../context/message';
import { gestorJson } from '../../utils/objectJson';
import { validationForm1 } from '../../utils/validationSchoolManager';





function Gestor() {
    const [removeLoad, setRemoveLoad] = useState(false)
    const navigation = useNavigate();
    const [listCountry, setContry] = useState([])
    const [listCity, setCity] = useState([])
    const [listUF, setListUF] = useState([])
    const [aux, setAux] = useState([]);
    const { setErrorMessage } = useContext(MessageContext);
    const [Identificacao, setIdentificacao] = useState(gestorJson)
    const { register, handleSubmit, setValue, formState: { errors } } = useForm({
        resolver: yupResolver(validationForm1)
    });


    const onSubmit = (data, e) => {
        e.preventDefault()
        setRemoveLoad(false)
        setTimeout(function () {
            sessionStorage.setItem('GestorEditar', JSON.stringify(Identificacao))
            if (sessionStorage.getItem('GestorEditar') !== '' || localStorage.getItem('GestorEditar') !== undefined) {
                setRemoveLoad(true)
                navigation('/gestor/editar-dados-pessoais')
            }
        }, 1000);
        //O valor é representado em milisegundos.
    };

    useEffect(() => {
        let Gestor = sessionStorage.getItem('GestorSelecionado')
        api.get('/schoolmanager/' + Gestor)
            .then(function (response) {
                // handle success
                setIdentificacao(response.data)
            }).catch((error) => {
                setErrorMessage([{message:"Erro ao buscar gestor", ok:false  }])
            })
            api.get('/resource/city/list-by-uf')
            .then(function (response) {
                // handle success

                setListUF(response.data);
            })
        api.get('/resource/country/list')
            .then(function (response) {
                // handle success
                setContry(response.data);
            })
        api.get('/resource/city/list')
            .then(function (response) {
                // handle success
                setCity(response.data);
                const Filtrados = response.data.filter((city) => city.uf.startsWith('PB'))
                setAux(Filtrados)
            })

     
        setRemoveLoad(true)
    }, [])

    function setExistsDeficiency(value) {
        setIdentificacao({ ...Identificacao, existsDeficiencyDisorder: Number(value) })
    }

    useEffect(() => {

        if (Identificacao.uf !== 'null') {
            const Filtrados = listCity.filter((city) => city.uf.startsWith(Identificacao.uf))
            setAux(Filtrados)
        }

    }, [Identificacao.uf])

    console.log('validations:', errors)
    
    return (

        <>
            {!removeLoad && <Loading />}
            <div className='span-message'>
                {Object.values(errors).map((item, key) => {
                    return (
                        <MessagePopUp key={key} myKey={key} text={item?.message} />
                    )
                })}
            </div>
            <App>
                <Container>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <InfoForm
                            title="Gestor"
                            wasChanged={Identificacao.wasChanged}
                            subtitle="Identificação"
                            positionPagination="1/2"
                        />
                        <FormContent style={{ marginTop: 15 }}>
                            <Box3Items>
                                <InputResponsive1
                                    type='text' title="1 - Identificação única (gerada pelo Inep)"
                                    register={register("inep")}
                                    maxlength='12'
                                    value={onlyNumber(Identificacao.inep)}
                                    {...setValue('inep', Identificacao.inep)}
                                    onChange={e => setIdentificacao({ ...Identificacao, inep: e.target.value })}
                                    erro={errors.inep?.message} />
                            </Box3Items>
                        </FormContent>
                        <FormContent style={{ marginTop: 20 }} >
                            <Box3Items>
                                <Box25>
                                    <InputResponsive1
                                        className='cpf'
                                        title="2 - Número do CPF" mandatory='*'
                                        name='cpf'
                                        maxlength='14'
                                        {...setValue('cpf', Identificacao.cpf)}
                                        value={cpfMask(Identificacao.cpf)}
                                        register={register('cpf')}
                                        erro={errors.cpf?.message}
                                        onChange={e => setIdentificacao({ ...Identificacao, cpf: e.target.value })} />
                                </Box25>
                            </Box3Items>
                            <BoxInput>
                                <InputResponsive1 name='completeName' title="3 - Nome Completo" mandatory='*'
                                    register={register('completeName')}
                                    value={onlyText(Identificacao.completeName)}
                                    {...setValue('completeName', Identificacao.completeName)}
                                    erro={errors.completeName?.message}
                                    onChange={e => setIdentificacao({ ...Identificacao, completeName: e.target.value.toUpperCase() })} />
                            </BoxInput>
                            <Box3Items>
                                <Box25 style={{ marginRight: 20 }}>
                                    <InputResponsive1 name='birthDate' type='date' title="4 - Data de nascimento" mandatory='*'
                                        register={register('birthDate')}
                                        {...setValue('birthDate', Identificacao.birthDate)}
                                        erro={errors.birthDate?.message}
                                        onChange={e => setIdentificacao({ ...Identificacao, birthDate: e.target.value })} />
                                </Box25>
                                <Box30  >
                                    <TitleFieldForm>
                                        5 - Filiação (informar o nome completo) <Madatory>*</Madatory>
                                    </TitleFieldForm>
                                    <Select
                                        name='filiation'

                                        {...register('filiation')}
                                        value={Identificacao.filiation.haveFiliation ?? -1}
                                        // {...setValue('filiation', Identificacao.filiation.haveFiliation ?? 0)}
                                        onChange={e => setIdentificacao({
                                            ...Identificacao, filiation: {
                                                ...Identificacao.filiation,
                                                haveFiliation: Number(e.target.value)
                                            }
                                        })}>
                                        <Option value={-1} disabled hidden>selecione</Option>
                                        <Option value={0}>Não declarado/Ignorado</Option>
                                        <Option value={1}>Filiação 1 e/ou Filiação 2</Option>
                                    </Select>
                                    <Message>{errors.filiation?.message}</Message>
                                </Box30>
                            </Box3Items>
                            <Box3Items style={{ display: Identificacao.filiation.haveFiliation !== 1 ? 'none' : 'flex' }}>
                                <Box50 style={{ marginRight: 20 }}>
                                    <InputResponsive1 title="5a - Filiação 1" mandatory='*'
                                        {...setValue('responsible1', Identificacao.filiation.responsible1)}
                                        register={register('responsible1')}
                                        erro={errors.responsible1?.message}
                                        onChange={e => setIdentificacao({
                                            ...Identificacao, filiation: {
                                                ...Identificacao.filiation,
                                                responsible1: e.target.value.toUpperCase() 
                                            }
                                        })} />
                                </Box50>
                                <Box50>
                                    <InputResponsive1 title="5b - filiação 2"
                                        name='responsible2'
                                        erro={errors.responsible2?.message}
                                        {...setValue('responsible2', Identificacao.filiation.responsible2 ?? '')}
                                        register={register('responsible2')}
                                        onChange={e => setIdentificacao({
                                            ...Identificacao, filiation: {
                                                ...Identificacao.filiation,
                                                responsible2: e.target.value.toUpperCase() 
                                            }
                                        })} />
                                </Box50>
                            </Box3Items>
                            <Box3Items>
                                <Box25 style={{ marginRight: 20 }}>
                                    <TitleFieldForm>
                                        6 - sexo  <Madatory>*</Madatory>
                                    </TitleFieldForm>
                                    <Select
                                        name='sex'
                                        {...register('sex')}
                                        {...setValue('sex', Identificacao.sex)}
                                        value={Identificacao.sex ?? 0}
                                        onChange={e => setIdentificacao({ ...Identificacao, sex: Number(e.target.value) })}>
                                        <Option value={0} disabled hidden>selecione</Option>
                                        <Option value={1}>Masculino</Option>
                                        <Option value={2}>Feminino</Option>
                                    </Select>
                                    <Message>{errors.sex?.message}</Message>
                                </Box25>
                                <Box25 >
                                    <TitleFieldForm>
                                        7 - Cor/Raça  <Madatory>*</Madatory>
                                    </TitleFieldForm>
                                    <Select

                                        name='colorRace'
                                        value={Identificacao.colorRace}
                                        {...register('colorRace')}
                                        {...setValue('colorRace', Identificacao.colorRace)}
                                        onChange={e => setIdentificacao({ ...Identificacao, colorRace: Number(e.target.value) })}>
                                        <Option disabled hidden>selecione</Option>
                                        <Option value={0}>Não declarado</Option>
                                        <Option value={1}>Branca</Option>
                                        <Option value={2}>Preta</Option>
                                        <Option value={3}>Parda</Option>
                                        <Option value={4}>Amarela</Option>
                                        <Option value={5}>Indigena</Option>
                                    </Select>
                                    <Message>{errors.colorRace?.message}</Message>
                                </Box25>
                            </Box3Items>
                            <Box2Items>
                                <Box50>
                                    <TitleFieldForm>
                                        8 - Nacionalidade  <Madatory>*</Madatory>
                                    </TitleFieldForm>
                                    <Select
                                        {...setValue('nationality', Identificacao.nationality ?? 0)}
                                        name='nationality'
                                        value={Identificacao.nationality ?? 0}
                                        {...register('nationality')}
                                        onChange={e => setIdentificacao({ ...Identificacao, nationality: Number(e.target.value) })} >
                                        <Option value={0} disabled hidden>selecione</Option>
                                        <Option key={1} value={1} >Brasileira</Option>
                                        <Option key={2} value={2}>Brasileira - nascido no Exterior ou Naturalizado</Option>
                                        <Option key={3} value={3}>Estrangeira</Option>
                                    </Select>
                                    <Message>{errors.nationality?.message}</Message>
                                </Box50>
                                <Box50>
                                    <TitleFieldForm>
                                        9 - Pais de Nacionalidade  <Madatory>*</Madatory>
                                    </TitleFieldForm>
                                    <Select
                                        name='nationalityCountry'
                                        {...register('nationalityCountry')}
                                        {...setValue('nationalityCountry', Identificacao.nationalityCountry ?? 0)}
                                        disabled={Identificacao.nationality !== 0 ? false : true}
                                        value={Identificacao.nationalityCountry ?? 0}
                                        onChange={e => setIdentificacao({ ...Identificacao, nationalityCountry: Number(e.target.value) })}  >
                                        <Option value={0} disabled hidden>selecione</Option>
                                        {listCountry.map((key) => {
                                            if (Identificacao.nationality === 1) {
                                                if (key.name === 'Brasil')
                                                    return <Option key={key.id + key.name} selected={true} value={key.ddi}>{key.name}</Option>;
                                            }
                                            else {
                                                return <Option key={key.id + key.name} value={key.ddi}>{key.name}</Option>;
                                            }
                                        })}
                                    </Select>
                                    <Message>{errors.nationalityCountry?.message}</Message>
                                </Box50>
                            </Box2Items>
                            <Box3Items style={{ display: Identificacao.nationality === 1 ? 'flex' : 'none' }} >
                                <Box30>
                                    <TitleFieldForm>
                                        10 - UF de nascimento  <Madatory>*</Madatory>
                                    </TitleFieldForm>
                                    <Select
                                        name='uf'
                                        {...register('uf')}
                                        {...setValue('uf', Identificacao.uf ?? 0)}
                                        value={Identificacao.uf ?? 0}
                                        onChange={e => setIdentificacao({ ...Identificacao, uf: e.target.value })}>
                                        <Option value={0} disabled hidden>selecione</Option>
                                        {Object.values(listUF).map(function (key, value) {
                                            return (

                                                <Option key={key} value={key}>{key}</Option>
                                            )
                                        })}
                                    </Select>
                                    <Message>{errors.uf?.message}</Message>
                                </Box30>
                                <Box50 style={{ marginLeft: 20 }}>
                                    <TitleFieldForm>
                                        11 - Municipio de Nascimento  <Madatory>*</Madatory>
                                    </TitleFieldForm>
                                    <Select
                                        name='cityBorn'

                                        {...register('cityBorn')}
                                        {...setValue('cityBorn', Identificacao.cityBorn ?? 0)}
                                        value={Identificacao.cityBorn ?? 0}
                                        // disabled={Identificacao.nationality === 1 ? false : true}
                                        onChange={e => setIdentificacao({ ...Identificacao, cityBorn: Number(e.target.value) })}>
                                        <Option value={0} disabled hidden>selecione</Option>
                                        {aux.map(function (key, index) {
                                            return <Option key={key.code} value={key.code}  >{key.name}</Option>
                                        })}
                                    </Select>
                                    <Message>{errors.cityBorn?.message}</Message>
                                </Box50>
                            </Box3Items>
                        </FormContent>
                        <FormContent style={{ marginTop: 20 }} >
                            <BoxInput>
                                <TitleFieldForm>
                                    12 - Gestor com deficiência, transtorno do espectro autista ou altas habilidades/superdotação <Madatory>*</Madatory>
                                </TitleFieldForm>
                                <Box3Items className='box-radio'>
                                    <input type='radio' className='radio' name='existsDeficiencyDisorder' {...register('existsDeficiencyDisorder')} {...setValue('existsDeficiencyDisorder', Identificacao.existsDeficiencyDisorder ?? 0)} title='Sim' id="yes" value={1} onChange={(e) => setExistsDeficiency(1)} checked={Number(Identificacao.existsDeficiencyDisorder) === 1} /><label className='info-radio'>Sim</label>
                                    <input type='radio' className='radio' name='existsDeficiencyDisorder' {...register('existsDeficiencyDisorder')}  {...setValue('existsDeficiencyDisorder', Identificacao.existsDeficiencyDisorder ?? 0)} title='Não' id="no" value={0} onChange={(e) => setExistsDeficiency(0)} checked={Number(Identificacao.existsDeficiencyDisorder) === 0} /> <label className='info-radio'>Não</label>
                                </Box3Items>
                            </BoxInput>
                            <FormContent style={{ display: Number(Identificacao.existsDeficiencyDisorder) === 1 ? 'flex' : 'none' }}>
                                <Box2Items style={{}}>
                                    <Box>
                                        <TitleFieldForm>Deficiência</TitleFieldForm>
                                        <Message style={{ display: !errors.deficiencyDisorder ? 'none' : 'flex' }}>escolha pelo menos uma das opções</Message>
                                        <Checkbox title='Baixa visão'
                                            id='teste'
                                            name='deficiencyDisorder[0]'
                                            setValue={setValue('deficiencyDisorder[0]', Identificacao.deficiencyDisorder.lowVision === 0 ? null : Identificacao.deficiencyDisorder.lowVision)}
                                            register={register("deficiencyDisorder[0]")}
                                            className='lowVision'
                                            checked={Identificacao.deficiencyDisorder.lowVision === 1 && Identificacao.existsDeficiencyDisorder === 1 ? true : false}
                                            onChange={e => {
                                                setIdentificacao({
                                                    ...Identificacao, deficiencyDisorder: {
                                                        ...Identificacao.deficiencyDisorder,
                                                        lowVision: e.target.checked === true ? 1 : 0,
                                                        blindness: 0,
                                                        deafBlindness: 0
                                                    }
                                                })
                                            }}
                                        />
                                        <Checkbox title='Visão monocular'
                                            id='teste'
                                            name='deficiencyDisorder[10]'
                                            setValue={setValue('deficiencyDisorder[10]', Identificacao.deficiencyDisorder.monocularVision === 0 ? null : Identificacao.deficiencyDisorder.monocularVision)}
                                            register={register("deficiencyDisorder[10]")}
                                            className='lowVision'
                                            checked={Identificacao.deficiencyDisorder.monocularVision === 1 && Identificacao.existsDeficiencyDisorder === 1 ? true : false}
                                            onChange={e => {
                                                setIdentificacao({
                                                    ...Identificacao, deficiencyDisorder: {
                                                        ...Identificacao.deficiencyDisorder,
                                                        monocularVision: e.target.checked === true ? 1 : 0,
                                                        blindness: 0,
                                                        deafBlindness: 0
                                                    }
                                                })
                                            }} />
                                        <Checkbox title='Cegueira'
                                            name='deficiencyDisorder[1]'
                                            setValue={setValue('deficiencyDisorder[1]', Identificacao.deficiencyDisorder.blindness === 0 ? null : Identificacao.deficiencyDisorder.blindness)}
                                            value={Identificacao.deficiencyDisorder.blindness}
                                            register={register("deficiencyDisorder[1]")}
                                            checked={Identificacao.deficiencyDisorder.blindness === 1 ? true : false}
                                            onChange={e => {
                                                setIdentificacao({
                                                    ...Identificacao, deficiencyDisorder: {
                                                        ...Identificacao.deficiencyDisorder,
                                                        blindness: e.target.checked ? 1 : 0,
                                                        lowVision: 0,
                                                        deafness: 0,
                                                        deafBlindness: 0,
                                                    }
                                                });
                                            }}
                                        />
                                        <Checkbox title='Deficiência auditiva'
                                            name='deficiencyDisorder[2]'
                                            setValue={setValue('deficiencyDisorder[2]', Identificacao.deficiencyDisorder.hearingDeficiency === 0 ? null : Identificacao.deficiencyDisorder.hearingDeficiency)}
                                            register={register("deficiencyDisorder[2]")}
                                            value={Identificacao.deficiencyDisorder.hearingDeficiency}
                                            checked={Identificacao.deficiencyDisorder.hearingDeficiency === 1 ? true : false}
                                            onChange={e => {
                                                setIdentificacao({
                                                    ...Identificacao, deficiencyDisorder: {
                                                        ...Identificacao.deficiencyDisorder,
                                                        hearingDeficiency: e.target.checked ? 1 : 0,
                                                        deafness: 0,
                                                        deafBlindness: 0
                                                    }
                                                });
                                            }}
                                        />
                                        <Checkbox title='Deficiência física'
                                            name='deficiencyDisorder[3]'
                                            setValue={setValue('deficiencyDisorder[3]', Identificacao.deficiencyDisorder.physicalDisability === 0 ? null : Identificacao.deficiencyDisorder.physicalDisability)}
                                            register={register("deficiencyDisorder[3]")}
                                            checked={Identificacao.deficiencyDisorder.physicalDisability === 1 ? true : false}
                                            onChange={e => {
                                                setIdentificacao({
                                                    ...Identificacao, deficiencyDisorder: {
                                                        ...Identificacao.deficiencyDisorder,
                                                        physicalDisability: e.target.checked ? 1 : 0
                                                    }
                                                });
                                            }}
                                        />
                                        <Checkbox title='Deficiência intelectual'
                                            name='deficiencyDisorder[4]'
                                            setValue={setValue('deficiencyDisorder[4]', Identificacao.deficiencyDisorder.intellectualDisability === 0 ? null : Identificacao.deficiencyDisorder.intellectualDisability)}

                                            register={register("deficiencyDisorder[4]")}
                                            value={Identificacao.deficiencyDisorder.intellectualDisability}
                                            checked={Identificacao.deficiencyDisorder.intellectualDisability === 1 ? true : false}
                                            onChange={e => {
                                                setIdentificacao({
                                                    ...Identificacao, deficiencyDisorder: {
                                                        ...Identificacao.deficiencyDisorder,
                                                        intellectualDisability: e.target.checked ? 1 : 0
                                                    }
                                                });
                                            }}
                                        />
                                        <Checkbox title='Surdez'
                                            name='deficiencyDisorder[5]'
                                            setValue={setValue('deficiencyDisorder[5]', Identificacao.deficiencyDisorder.deafness ?? 0)}
                                            register={register("deficiencyDisorder[5]")}
                                            value={Identificacao.deficiencyDisorder}
                                            checked={Identificacao.deficiencyDisorder.deafness === 1 ? true : false}
                                            onChange={e => {
                                                setIdentificacao({
                                                    ...Identificacao, deficiencyDisorder: {
                                                        ...Identificacao.deficiencyDisorder,
                                                        deafness: e.target.checked ? 1 : 0,
                                                        blindness: 0,
                                                        hearingDeficiency: 0,
                                                        deafBlindness: 0,
                                                    }
                                                });
                                            }}
                                        />
                                        <Checkbox title='Surdocegueira'
                                            name='deficiencyDisorder[6]'
                                            setValue={setValue('deficiencyDisorder[6]', Identificacao.deficiencyDisorder.deafBlindness === 0 ? null : Identificacao.deficiencyDisorder.deafBlindness)}
                                            register={register("deficiencyDisorder[6]")}
                                            value={Identificacao.deficiencyDisorder.deafBlindness}
                                            checked={Identificacao.deficiencyDisorder.deafBlindness === 1 ? true : false}
                                            onChange={e => {
                                                setIdentificacao({
                                                    ...Identificacao, deficiencyDisorder: {
                                                        ...Identificacao.deficiencyDisorder,
                                                        deafBlindness: e.target.checked ? 1 : 0,
                                                        blindness: 0,
                                                        deafness: 0,
                                                        hearingDeficiency: 0
                                                    }
                                                });
                                            }}
                                        />
                                        {/*
                            aplicar a regra quando tiver mais de 1 campo habilitado desse formulario deficiencia
                            deverá ser marcado com '1' , caso contrario '0'
                            */}
                                        <Checkbox title='Deficiência multipla'
                                            name='deficiencyDisorder[7]'
                                            setValue={setValue('deficiencyDisorder[7]', Identificacao.deficiencyDisorder.multipleDisability === 0 ? null : Identificacao.deficiencyDisorder.multipleDisability)}
                                            register={register("deficiencyDisorder[7]")}
                                            value={Identificacao.deficiencyDisorder.multipleDisability}
                                            checked={Identificacao.deficiencyDisorder.multipleDisability === 1 ? true : false}
                                            onChange={e => {
                                                setIdentificacao({
                                                    ...Identificacao, deficiencyDisorder: {
                                                        ...Identificacao.deficiencyDisorder,
                                                        multipleDisability: e.target.checked ? 1 : 0
                                                    }
                                                });
                                            }}
                                        />
                                    </Box>
                                    <Box>
                                        <TitleFieldForm style={{ marginTop: 10 }}>
                                            Transtorno do espectro autista
                                        </TitleFieldForm>
                                        <Checkbox title='Transtorno do espectro autista'
                                            name='deficiencyDisorder[8]'
                                            setValue={setValue('deficiencyDisorder[8]', Identificacao.deficiencyDisorder.autisticSpectrumDisorder === 0 ? null : Identificacao.deficiencyDisorder.autisticSpectrumDisorder)}
                                            register={register("deficiencyDisorder[8]")}
                                            value={Identificacao.deficiencyDisorder.autisticSpectrumDisorder}
                                            checked={Identificacao.deficiencyDisorder.autisticSpectrumDisorder === 1 ? true : false}
                                            onChange={e => {
                                                setIdentificacao({
                                                    ...Identificacao, deficiencyDisorder: {
                                                        ...Identificacao.deficiencyDisorder,
                                                        autisticSpectrumDisorder: e.target.checked ? 1 : 0
                                                    }
                                                });
                                            }}
                                        />
                                    </Box>
                                    <Box>
                                        <TitleFieldForm style={{ marginTop: 10 }}>
                                            Altas habilidades/superdotação
                                        </TitleFieldForm>
                                        <Checkbox title='Altas habilidades/superdotação'
                                            name='deficiencyDisorder[9]'
                                            setValue={setValue('deficiencyDisorder[9]', Identificacao.deficiencyDisorder.highSkills === 0 ? null : Identificacao.deficiencyDisorder.highSkills)}
                                            register={register("deficiencyDisorder[9]")}
                                            value={Identificacao.deficiencyDisorder.highSkills}
                                            checked={Identificacao.deficiencyDisorder.highSkills === 1 ? true : false}
                                            onChange={e => {
                                                setIdentificacao({
                                                    ...Identificacao, deficiencyDisorder: {
                                                        ...Identificacao.deficiencyDisorder,
                                                        highSkills: e.target.checked ? 1 : 0
                                                    }
                                                });
                                            }}
                                        />
                                    </Box>
                                </Box2Items>
                                {/* aplicar regra para quando algum dos campos esteja ativado do formulario acima
                    seja possivel escolher os recurso de acordo com a deficiencia
                */}
                            </FormContent>
                        </FormContent>
                        <ButtonFormFooter
                            textNext="Próximo"
                            linkBack={"/gestor/pesquisar"}
                        />
                    </form>
                </Container>
            </App>
        </>

    )
}
export default Gestor;